import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

// The (relative) prefix to include in URLs for routing. E.g. if the
// complete URL is 'https://example.com/sick/emailz/editor/TEMPLATE-123/edit'
// then the basePath is 'sick/campaignz' because the remainder of the path
// was constructed by this lib.  See PAGE_ROUTES.
export const EMAIL_LIBRARY_BASE_URL_TOKEN = new InjectionToken<Observable<string>>('com.vendasta.campaigns.base_url');

export const PAGE_ROUTES = {
  ROOT: {
    TEMPLATE_SUBROUTES: {
      EDIT: (templateID: string) => `editor/${templateID}`,
      NEW: 'editor/new',
    },
  },
};
